import { AmpPluginComponent } from '../amp-plugin';
import { svgParser } from '../../utils/svg-parser';
import { debug } from '../../utils/debug-log';
import { EVENT_READY as AMP_EVENTS_SOURCES_READY } from '../amp-events-sources/amp-events-sources.constants';

//let showTapForSound = true;
export class TapForSound extends AmpPluginComponent {
    constructor(player, config, key) {
        super(player, config, key);

        this._button = null;
        this.subscriptions = [];
        require('./styles.scss');
        debug.log("[TapForSound] Constructor config:", config);
    }
    get label() {
        let label = "Unmute Audio";
        if (this.config.label != null && this.config.label.length > 0) {
            label = this.config.label;
        }
        return label;
    }
    get button() {
        if (this._button == null) {
            let button = document.createElement('button');
            let label = document.createElement("span");
            let iconContainer = document.createElement("span");
            label.classList.add('label');
            iconContainer.classList.add("icon-container");
            label.innerHTML = this.label;
            iconContainer.appendChild(this.icon);
            button.appendChild(iconContainer);
            button.appendChild(label);
            this._button = button;
        }
        return this._button;
    }
    get icon() {
        const svgString = `
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2739 2.24768C20.9416 4.00855 21.9629 6.38363 21.9629 8.9994C21.9629 11.6152 20.9416 13.9903 19.2739 15.7511C18.8942 16.1521 18.9114 16.7851 19.3124 17.1648C19.7134 17.5446 20.3463 17.5274 20.7261 17.1264C22.7314 15.0089 23.9629 12.1469 23.9629 8.9994C23.9629 5.85194 22.7315 2.98994 20.7261 0.87244C20.3463 0.471443 19.7134 0.454228 19.3124 0.833991C18.9114 1.21375 18.8942 1.84668 19.2739 2.24768ZM7.08579 2.00008C8.34572 0.740143 10.5 1.63249 10.5 3.41429V14.5859C10.5 16.3677 8.34572 17.26 7.08579 16.0001L4.08579 13.0001H2C0.89543 13.0001 0 12.1046 0 11.0001V7.00008C0 5.89551 0.895431 5.00008 2 5.00008L4.08579 5.00008L7.08579 2.00008ZM18.1789 8.9994C18.1789 7.22094 17.4593 5.61248 16.2929 4.44609C15.9024 4.05557 15.9024 3.4224 16.2929 3.03188C16.6834 2.64135 17.3166 2.64135 17.7071 3.03188C19.2332 4.55801 20.1789 6.66921 20.1789 8.9994C20.1789 11.3296 19.2332 13.4408 17.7071 14.9669C17.3166 15.3574 16.6834 15.3574 16.2929 14.9669C15.9024 14.5764 15.9024 13.9432 16.2929 13.5527C17.4593 12.3863 18.1789 10.7779 18.1789 8.9994ZM13.2929 6.83717C13.8473 7.39163 14.1885 8.15471 14.1885 8.99938C14.1885 9.84406 13.8473 10.6071 13.2929 11.1616C12.9024 11.5521 12.9024 12.1853 13.2929 12.5758C13.6834 12.9663 14.3166 12.9663 14.7071 12.5758C15.6213 11.6616 16.1885 10.3958 16.1885 8.99938C16.1885 7.60298 15.6213 6.33715 14.7071 5.42296C14.3166 5.03244 13.6834 5.03244 13.2929 5.42296C12.9024 5.81349 12.9024 6.44665 13.2929 6.83717Z" fill="white"/>
        </svg>
        `;
        const svgEl = svgParser(svgString);
        return svgEl;
    }

    destroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        })
        this.subscriptions = [];
    }
    init() {
        let { player } = this;
        debug.log("[TapForSound] init:player", player);
        if (player.config.autoplay === true) {
            if (player.AmpEventsSources == null) {
                player.addEventListener(AMP_EVENTS_SOURCES_READY, e => {
                    debug.log("[TapForSound] AMP_EVENTS_SOURCES_READY", e);
                    if (player.playState !== 'playing') {
                        let playing$ = player.AmpEventsSources['timeupdate'].subscribe(eventData => {
                            playing$.unsubscribe();
                            this.handlePlaying();
                        })
                    } else {
                        this.handlePlaying();
                    }
                })
            } else if (player.playState !== 'playing') {
                    let playing$ = player.AmpEventsSources['timeupdate'].subscribe(eventData => {
                        playing$.unsubscribe();
                        this.handlePlaying();
                    })

            } else {
                this.handlePlaying();
            }
        }

    }
    handlePlaying() {
        debug.log("[TapForSound] handlePlaying",this.player.AmpEventsSources);
        let { player, el, button } = this;

        if (this.config.show === true && player.getMuted() === true) {
            el.classList.add('tap-for-sound-plugin');
            el.classList.add('amp-layer');
            el.appendChild(button);
            player.container.appendChild(el);

            const handleClick = (e) => {
                debug.log("[TapForSound] handleClick:", e)
                player.unmute();
            }

            el.addEventListener('click', handleClick)
            button.addEventListener('click', handleClick)

            let mutechange$ = player.AmpEventsSources["mutechange"].subscribe(data => {
                debug.log("[TapForSound] mutechange:", data);
                if (data.state.isMuted === false) {

                    this.destroy();
                    el.removeEventListener('click', handleClick);
                    button.removeEventListener('click', handleClick);
                    if (this.el.remove) {
                        this.el.remove();
                    } else {
                        // IE doesn't support remove
                        this.el.parentNode.removeChild(this.el);
                    }
                    this.config.show = false;
                }
            })

            let end$ = player.AmpEventsSources["ended"].subscribe(eventData => {
                el.classList.add("hidden");
            })

            let playing$ = player.AmpEventsSources["playing"].subscribe(eventData => {
                el.classList.remove("hidden");
            })
            let destroy$ = player.AmpEventsSources["destroy"].subscribe(eventData => {
                this.destroy();
            })

            this.subscriptions = [mutechange$, end$, playing$, destroy$];
        }
    }

}